import { useState } from "react";
import { useForm } from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form/useForm";
import Form from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form";
import {
  webhookNotificationNodeSchema,
  webhookNotificationNodeTemplate,
} from "../../models/endNode";
import { Button } from "V2.0/common/button";
import { PlusIcon, TrashIcon } from "@heroicons/react/24/outline";
import { WebhookForm } from "V2.0/HomePages/Assistants/AssistantTools/Webhooks/WebhookForm";
import { Dialog, DialogTitle, DialogBody } from "V2.0/common/dialog";
import { Tooltip } from "antd";

function WebhookAdd(props) {
  const { onSubmit } = props;
  const [openWebhookForm, setOpenWebhookForm] = useState(false);

  return (
    <>
      <Button outline onClick={() => setOpenWebhookForm(true)}>
        <PlusIcon /> Webhook
      </Button>
      {openWebhookForm && (
        <Dialog
          open={openWebhookForm}
          onClose={() => setOpenWebhookForm(false)}
        >
          <DialogTitle>Add Webhook</DialogTitle>
          <DialogBody>
            <WebhookForm
              loading={false}
              setLoading={() => {}}
              handleClose={() => setOpenWebhookForm(false)}
              onSubmit={(data) => {
                onSubmit(data);
                setOpenWebhookForm(false);
              }}
            />
          </DialogBody>
        </Dialog>
      )}
    </>
  );
}

function WebhookNotificationNode(props) {
  const { node, setNodes, closePanel, projectId, notifyChange, options } =
    props;
  const [webhookNotificationSettings, setWebhookNotificationSettings] =
    useState({ ...node?.data?.settings });
  const [state, setState] = useState({
    name: node?.data?.settings?.name || "",
    description: node?.data?.settings?.description || "",
    endNodeType: node?.data?.settings?.endNodeType,
    maxRetries: node?.data?.settings?.maxRetries || 0,
    retryDelayMs: node?.data?.settings?.retryDelayMs || 0,
    completionStatus: node?.data?.settings?.completionStatus
  });

  const { data, error, validate, handleChange, setError } = useForm(
    state,
    webhookNotificationNodeSchema
  );

  function addWebhook(data) {
    setWebhookNotificationSettings((prevSettings) => {
      return {
        ...prevSettings,
        webhookList: [...prevSettings.webhookList, data],
      };
    });
  }

  function deleteWebhook(idx) {
    setWebhookNotificationSettings((prevSettings) => {
      return {
        ...prevSettings,
        webhookList: prevSettings.webhookList.toSpliced(idx, 1),
      };
    });
  }

  function handleSave() {
    const errors = validate(data, webhookNotificationNodeSchema);

    if (errors) {
      setError(errors);
      return;
    }

    const payload = {
      ...webhookNotificationSettings,
      ...data,
    };

    setNodes((nodes) => {
      const updatedNodes = nodes.map((_node) => {
        if (_node.id === node.id) {
          const { selected, ...rest } = _node;
          return {
            ...rest,
            selected: false,

            data: {
              ...node.data,
              settings: { ...node.data.settings, ...payload },
            },
          };
        } else {
          return _node;
        }
      });
      return updatedNodes;
    });
    closePanel();
    notifyChange();
  }

  return (
    <>
      <div className="flex flex-col gap-y-4">
        <Form
          data={data}
          handleChange={handleChange}
          error={error}
          template={webhookNotificationNodeTemplate}
        />
        <div>
          <div className="flex justify-between items-center pb-2 border-b">
            <p className="font-semibold text-sm">Webhooks ({webhookNotificationSettings?.webhookList.length})</p>
            <WebhookAdd onSubmit={addWebhook} />
          </div>
          {webhookNotificationSettings?.webhookList.length > 0 && (
            <div className="flex flex-col gap-y-4 border rounded-lg p-4 mt-2 max-h-[300px] overflow-scroll">
              {webhookNotificationSettings?.webhookList.map((item, idx) => {
                return (
                  <div className="flex items-between p-1 border-b gap-x-4">
                    <Tooltip title={item.endpointUrl}>
                      <p className="truncate max-w-[300px]">
                        {item.endpointUrl}
                      </p>
                    </Tooltip>
                    <div>
                      <Button onClick={() => deleteWebhook(idx)} outline>
                        <TrashIcon />
                      </Button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <div className="flex self-end">
          <Button onClick={handleSave}>save</Button>
        </div>
      </div>
    </>
  );
}

export { WebhookNotificationNode };
